module.exports = __webpack_public_path__ + "static/image/history/m/201211@3x.ver2_0_2.jpg?4e1ee9f6";